import Route from '@ember/routing/route';
import { service } from '@ember/service';
import Store from '@ember-data/store';
import AdminFundGroupModel from 'donor-elf-web/models/admin/fund-group';

export interface FundGroupRouteModel {
  fundGroup?: AdminFundGroupModel;
}

export default class FundGroupRoute extends Route {
  @service declare storeCache: any;
  @service declare store: Store;

  async model(params: { id: string }): Promise<FundGroupRouteModel> {
    if (params.id === 'add') {
      return {};
    }

    let fundGroup = await this.store.findRecord('admin/fund-group', params.id);
    return {
      fundGroup: fundGroup,
    };
  }
}
